export { Spectrum } from './spectrum'
